export default __webpack_public_path__ + "static/media/chevron_right_blue.53ca0e71.svg";